export const DecisionActionBarEN = {
    "decisionActionBar": {
        "tab": {
            "detail":"Detail",
        },
        "item": {
            "delete": "Delete",
            "history": "History",
            "update": "Update",
            "approval": "Approval"
        }
    }
}